export const auth = {
  login: 'Login',
  loginSubtitle: 'Sign in to manage your customers',
  register: 'Register',
  registerSubtitle: 'Create a new account',
  resetPassword: 'Reset Password',
  resetSubtitle: 'Enter your email to reset your password',
  email: 'Email address',
  password: 'Password',
  displayName: 'Full name',
  forgotPassword: 'Forgot your password?',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  or: 'or',
  signInWithGoogle: 'Sign in with Google',
  signUpWithGoogle: 'Sign up with Google',
  acceptTerms: 'I accept the',
  termsOfService: 'Terms of Service',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  signUp: 'Sign Up',
  backToLogin: 'Back to login',
  sendResetLink: 'Send reset link',
  resetEmailSent: 'Password reset email sent',
  invalidEmail: 'Invalid email address',
  invalidPassword: 'Password must be at least 6 characters',
  requiredField: 'This field is required',
  processing: 'Processing...',
  passwordTooShort: 'Password must be at least 6 characters long',
  passwordRequired: 'Password is required',
  emailRequired: 'Email address is required',
  displayNameRequired: 'Name is required',
  invalidCredentials: 'Invalid email or password.',
  attemptsRemaining: '{{count}} attempt(s) remaining.',
  accountLocked: 'Too many failed attempts. Please try again in {{minutes}} minutes.',
  accountLockedSeconds: 'Too many failed attempts. Please try again in {{seconds}} seconds.',
  accountLockedContactAdmin: 'Too many failed attempts. Please contact the administrator.',
  mfaTitle: 'Two-Factor Authentication',
  mfaSubtitle: 'Enter the 6-digit code from your Authenticator app',
  verificationCode: 'Verification code',
  codeChangesEvery: 'The code changes every 30 seconds',
  verifying: 'Verifying...',
  cancel: 'Cancel',
  mfaTip: 'Open the Authenticator app on your phone and enter the current 6-digit code.',
  mfaTipLabel: 'Tip:',
  mfaCodeLengthError: 'The code must be 6 digits',
  mfaSmsNotSupported: 'SMS-based MFA is not supported in this version',
  mfaUnknownFactor: 'Unknown MFA type',
  mfaInvalidCode: 'Invalid code. Try again!',
  mfaCodeExpired: 'The code has expired. Request a new one!',
  mfaVerificationError: 'Error during verification: '
};
